<template>
	<v-sheet elevation="0">
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="pageTitle">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-btn color="primary" @click="openFixDialog" dark
					><v-icon>mdi-clock-edit-outline</v-icon>更新履歴</v-btn
				>
				<v-btn v-if="authorized" color="primary" @click="redirectToEditPage" dark
					><v-icon>mdi-pencil</v-icon>編集</v-btn
				>
			</template>
			<template v-if="$vuetify.breakpoint.xs">
				<v-btn color="secondary" class="ml-2" @click="openFixDialog">
					<v-icon class="mr-1">mdi-clock-edit-outline</v-icon>
					更新履歴
				</v-btn>
				<v-btn v-if="authorized" color="secondary" class="ml-2" @click="redirectToEditPage">
					<v-icon class="mr-1">mdi-pencil</v-icon>
					編集
				</v-btn>
			</template>

			<v-sheet elevation="0">
				<div v-if="!is_approved">
					<v-alert
						outlined
						type="warning"
						color="red"
						:class="$vuetify.breakpoint.sm ? 'ma-1' : 'mt-4'"
					>
						<span class="warning-text-color">
							この受注内容確認書は未承認です。
							<span v-if="authorized">
								<a @click="openApprovalDialog" class="link"> こちら </a>
								から承認をしてください。
							</span>
						</span>
					</v-alert>
				</div>

				<v-row no-gutters>
					<v-col :class="$vuetify.breakpoint.mdAndUp ? 'pr-2' : ''" cols="12" md="6">
						<v-row no-gutters class="px-1 pt-2 show-unit">
							<v-col cols="12" :sm="12" :class="$vuetify.breakpoint.sm ? '' : 'pb-2'">
								<h4 class="text-sm-body-1 text-h6 font-weight-bold color-secondary">基本情報</h4>
							</v-col>
							<v-col cols="12" :sm="12">
								<v-row no-gutters class="pb-2 show-detail-unit">
									<v-col cols="5">
										<h5 class="text-body-2 font-weight-bold">受注日</h5>
									</v-col>
									<v-col cols="7">
										<p class="text-body-2">
											{{ order_confirmation.matter.order_date | dateFormatter }}
										</p>
									</v-col>
								</v-row>

								<v-row no-gutters class="pb-2 show-detail-unit">
									<v-col cols="5">
										<h5 class="text-body-2 font-weight-bold">作成者</h5>
									</v-col>
									<v-col cols="7">
										<p class="text-body-2">{{ order_confirmation.created_user.full_name }}</p>
									</v-col>
								</v-row>

								<v-row no-gutters class="pb-2 show-detail-unit">
									<v-col cols="5">
										<h5 class="text-body-2 font-weight-bold">作成日</h5>
									</v-col>
									<v-col cols="7">
										<p class="text-body-2">{{ order_confirmation.created_at | dateFormatter }}</p>
									</v-col>
								</v-row>

								<v-row no-gutters class="pb-2 show-detail-unit">
									<v-col cols="5">
										<h5 class="text-body-2 font-weight-bold">最終更新日時</h5>
									</v-col>
									<v-col cols="7">
										<p class="text-body-2">
											{{ order_confirmation.updated_at | datetimeFormatter }}
										</p>
									</v-col>
								</v-row>

								<v-row no-gutters class="pb-2 show-detail-unit">
									<v-col cols="5">
										<h5 class="text-body-2 font-weight-bold">現在の承認状態</h5>
									</v-col>
									<v-col cols="7">
										<p class="text-body-2">
											{{ order_confirmation.approval_status | approvalFormatter }}
										</p>
									</v-col>
								</v-row>

								<v-row no-gutters class="pb-2 show-detail-unit" v-if="is_approved">
									<v-col cols="5">
										<h5 class="text-body-2 font-weight-bold">承認者</h5>
									</v-col>
									<v-col cols="7">
										<p
											class="text-body-2"
											v-for="user_name in order_confirmation.approved_users"
											:key="user_name"
										>
										{{ user_name }}</p>
									</v-col>
								</v-row>

								<v-row no-gutters class="pb-2 show-detail-unit">
									<v-col cols="5">
										<h5 class="text-body-2 font-weight-bold">受注No</h5>
									</v-col>
									<v-col cols="7">
										<p class="text-body-2">{{ order_confirmation.matter.order_number }}</p>
									</v-col>
								</v-row>

								<v-row no-gutters class="pb-2 show-detail-unit">
									<v-col cols="5">
										<h5 class="text-body-2 font-weight-bold">受注金額</h5>
									</v-col>
									<v-col cols="7">
										<p class="text-body-2">
											{{ Number(order_confirmation.matter.ordered_amount).toLocaleString() + "円" }}
										</p>
									</v-col>
								</v-row>

								<h4
									class="text-sm-body-1 text-h6 font-weight-bold color-secondary py-2"
									style="border-top: 1px solid lightgray"
								>
									製品情報
								</h4>

							<div>
								<v-row
									v-for="ordered_product in order_confirmation.matter.ordered_products"
									:key="ordered_product.id"
									no-gutters
									class="pb-2 show-detail-unit product-info"
								>
									<v-col cols="5">
										<h5 class="text-body-2 font-weight-bold">製品名</h5>
									</v-col>
									<v-col cols="7">
										<p class="text-body-2">
											{{ ordered_product.product ? ordered_product.product.name : "" }}
										</p>
									</v-col>
									<v-col cols="5">
										<h5 class="text-body-2 font-weight-bold">製品カテゴリー</h5>
									</v-col>
									<v-col cols="7">
										<p class="text-body-2">
											{{
												ordered_product.product.product_category
													? ordered_product.product.product_category.name
													: ""
											}}
										</p>
									</v-col>
									<v-col cols="5">
										<h5 class="text-body-2 font-weight-bold">製品サブカテゴリー</h5>
									</v-col>
									<v-col cols="7">
										<p class="text-body-2">
											{{
												ordered_product.product.product_sub_category
													? ordered_product.product.product_sub_category.name
													: ""
											}}
										</p>
									</v-col>
									<v-col cols="5">
										<h5 class="text-body-2 font-weight-bold">製造番号</h5>
									</v-col>
									<v-col cols="7">
										<p class="text-body-2">{{ ordered_product.product_number }}</p>
									</v-col>

									<v-col cols="5">
										<h5 class="text-body-2 font-weight-bold">受注数量</h5>
									</v-col>
									<v-col cols="7">
										<p class="text-body-2">{{ ordered_product.quantity }}</p>
									</v-col>

									<v-col cols="5">
										<h5 class="text-body-2 font-weight-bold">受注単価</h5>
									</v-col>
									<v-col cols="7">
										<p class="text-body-2">{{ ordered_product.unit_price.toLocaleString() }}</p>
									</v-col>

									<v-col cols="5">
										<h5 class="text-body-2 font-weight-bold">納入先</h5>
									</v-col>
									<v-col cols="7">
										<p class="text-body-2">
											{{
												ordered_product.delivery_info
													? ordered_product.delivery_info.company_name
													: ""
											}}
										</p>
									</v-col>

									<v-col cols="5">
										<h5 class="text-body-2 font-weight-bold">納入先TEL</h5>
									</v-col>
									<v-col cols="7">
										<p class="text-body-2">{{ ordered_product.delivery_info.phone }}</p>
									</v-col>

									<v-col cols="5">
										<h5 class="text-body-2 font-weight-bold">納入先郵便番号</h5>
									</v-col>
									<v-col cols="7">
										<p class="text-body-2">{{ ordered_product.delivery_info.zipcode }}</p>
									</v-col>

									<v-col cols="5">
										<h5 class="text-body-2 font-weight-bold">納入先都道府県</h5>
									</v-col>
									<v-col cols="7">
										<p class="text-body-2">{{ ordered_product.delivery_info.prefecture }}</p>
									</v-col>

									<v-col cols="5">
										<h5 class="text-body-2 font-weight-bold">納入先住所</h5>
									</v-col>
									<v-col cols="7">
										<p class="text-body-2">{{ ordered_product.delivery_info.address }}</p>
									</v-col>

									<v-col cols="5">
										<h5 class="text-body-2 font-weight-bold">納入先市郡町村</h5>
									</v-col>
									<v-col cols="7">
										<p class="text-body-2">{{ ordered_product.delivery_info.city }}</p>
									</v-col>

								<div class="border"></div>
								</v-row>
							</div>


								<v-row no-gutters class="px-1 pt-2 mt-2 show-unit">
									<v-col cols="12" :sm="12" :class="$vuetify.breakpoint.sm ? '' : 'pb-2'">
										<h4 class="text-sm-body-1 text-h6 font-weight-bold color-secondary">
											エンドユーザー
										</h4>
									</v-col>
									<v-col cols="12" :sm="12">
										<v-row no-gutters class="pb-2 show-detail-unit">
											<v-col cols="5">
												<h5 class="text-body-2 font-weight-bold">会社</h5>
											</v-col>
											<v-col cols="7">
												<p class="text-body-2">
													{{
														order_confirmation.matter.customer_company
															? order_confirmation.matter.customer_company.name
															: ""
													}}
												</p>
											</v-col>
										</v-row>
									</v-col>
								</v-row>

								<v-row no-gutters class="px-1 pt-2 show-unit">
									<v-col cols="12" :sm="12" :class="$vuetify.breakpoint.sm ? '' : 'pb-2'">
										<h4 class="text-sm-body-1 text-h6 font-weight-bold color-secondary">
											プラントメーカー
										</h4>
									</v-col>
									<v-col cols="12" :sm="12">
										<v-row no-gutters class="pb-2 show-detail-unit">
											<v-col cols="5">
												<h5 class="text-body-2 font-weight-bold">会社</h5>
											</v-col>
											<v-col cols="7">
												<p class="text-body-2">
													{{
														order_confirmation.matter.plant_customer_company
															? order_confirmation.matter.plant_customer_company.name
															: ""
													}}
												</p>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</v-col>

					<v-col v-if="!$vuetify.breakpoint.mdAndUp" cols="12">
						<v-divider />
					</v-col>

					<v-col :class="$vuetify.breakpoint.mdAndUp ? 'pl-2' : ''" cols="12" md="6">
						<v-row no-gutters class="px-1 pt-2 show-unit">
							<v-col cols="12" :sm="3" :class="$vuetify.breakpoint.sm ? '' : 'pb-2'">
								<h4 class="text-sm-body-1 text-h6 font-weight-bold color-secondary">
									顧客要求事項
								</h4>
							</v-col>
						</v-row>
						<v-col cols="12" :sm="12">
							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">見積書No</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">{{}}</p>
								</v-col>
							</v-row>
							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">注文書No</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">{{}}</p>
								</v-col>
							</v-row>
							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">仮手配No</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">{{}}</p>
								</v-col>
							</v-row>
							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">図書作成依頼票管理番号</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">{{}}</p>
								</v-col>
							</v-row>
							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">引合仕様検討依頼番号</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">{{}}</p>
								</v-col>
							</v-row>
							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">原価番号</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">{{}}</p>
								</v-col>
							</v-row>
							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">工事引合仕様書No</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">{{}}</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">手配元(ライニング製品の母材)</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">{{ order_confirmation.source_of_base_material | sourceOfBaseMaterialFormatter }}</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">手配可否</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">{{order_confirmation.arrangement_availability | arrangementAvailabilityFormatter}}
									</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">支給予定日</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">{{ order_confirmation.scheduled_date_of_payment | dateFormatter }}</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">製品の承認予定日</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">{{ order_confirmation.scheduled_date_of_approval | dateFormatter }}</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">輸送方法</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">{{ order_confirmation.transport ? order_confirmation.transport : "" }}</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">手配元(輸送)</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">{{ order_confirmation.source_of_transport | sourceOfTransportFormatter }}</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">塗装区分の有無</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">{{ order_confirmation.exists_coating | booleanFormatter }}</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="12" md="4" lg="4">
									<h5 class="text-body-2 font-weight-bold">塗装の補足</h5>
								</v-col>
								<v-col cols="12" md="8" lg="8">
									<p class="text-body-2 text-body-2--new-line">{{ order_confirmation.coating_content }}</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">工程写真区分の有無</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">{{ order_confirmation.exists_process_photo | booleanFormatter }}</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="12" md="4" lg="4">
									<h5 class="text-body-2 font-weight-bold">工程写真の補足</h5>
								</v-col>
								<v-col cols="12" md="8" lg="8">
									<p class="text-body-2 text-body-2--new-line">{{ order_confirmation.process_photo_content }}</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">水協検査区分の有無</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">{{ order_confirmation.exists_water_works | booleanFormatter }}</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="12" md="4" lg="4">
									<h5 class="text-body-2 font-weight-bold">水協検査の補足</h5>
								</v-col>
								<v-col cols="12" md="8" lg="8">
									<p class="text-body-2 text-body-2--new-line">{{ order_confirmation.water_works_content }}</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">立会区分の有無</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">{{ order_confirmation.exists_witness | booleanFormatter }}</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="12" md="4" lg="4">
									<h5 class="text-body-2 font-weight-bold">立会区分の補足</h5>
								</v-col>
								<v-col cols="12" md="8" lg="8">
									<p class="text-body-2 text-body-2--new-line">{{ order_confirmation.witness_content }}</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">梱包指定区分の有無</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">{{ order_confirmation.exists_packaging | booleanFormatter }}</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="12" md="4" lg="4">
									<h5 class="text-body-2 font-weight-bold">梱包指定の補足</h5>
								</v-col>
								<v-col cols="12" md="8" lg="8">
									<p class="text-body-2 text-body-2--new-line">{{ order_confirmation.packaging_content }}</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">出荷時添付書類の有無</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">{{ order_confirmation.exists_attached_file | booleanFormatter }}</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="12" md="4" lg="4">
									<h5 class="text-body-2 font-weight-bold">出荷時添付書類の内容</h5>
								</v-col>
								<v-col cols="12" md="8" lg="8">
									<p class="text-body-2">{{ order_confirmation.attached_file_content }}</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="12" md="4" lg="4">
									<h5 class="text-body-2 font-weight-bold">生産企画部記載欄</h5>
								</v-col>
								<v-col cols="12" md="8" lg="8">
									<p class="text-body-2 text-body-2--new-line">{{ order_confirmation.content }}</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">見積原価の有無</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">
										{{ order_confirmation.exists_quotation_cost | booleanFormatter }}
									</p>
								</v-col>
							</v-row>

							<v-row no-gutters class="pb-2 show-detail-unit">
								<v-col cols="4">
									<h5 class="text-body-2 font-weight-bold">受注金額入力の有無</h5>
								</v-col>
								<v-col cols="8">
									<p class="text-body-2">
										{{ order_confirmation.exists_order_amount | booleanFormatter }}
									</p>
								</v-col>
							</v-row>
						</v-col>
					</v-col>

					<v-col cols="12" :sm="12" :class="$vuetify.breakpoint.sm ? '' : 'pb-2'">
						<h4 class="text-sm-body-1 text-h6 font-weight-bold color-secondary">添付ファイル</h4>
					</v-col>
					<v-col cols="12" :sm="12">
						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-btn
								small
								outlined
								class="ma-1 btn-no-transform"
								color="primary"
								v-for="file in order_confirmation.file_url"
								:key="file.id"
								:href="file.url"
								target="_blank"
							>
								<v-icon class="mr-2">mdi-download</v-icon>
								{{ file.name }}
							</v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-sheet>
		</CommonFlame>
		<OrderConfirmationFixIndexDialog
			v-if="fixDialog"
			:fixes="order_confirmation.order_confirmation_fixes"
			:authorized="authorized"
			@approve="approve($event)"
			@close="fixDialog = false"
		/>
		<ApproveDialog
			v-if="approveDialog"
			:matter_id="matter_id"
			:authorized="authorized"
			@approve="approve($event)"
			@reject="reject($event)"
			@close="approveDialog = false"
		/>
	</v-sheet>
</template>

<script>
import moment from "moment/min/moment.min.js"
import axios from "axios"

import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import OrderConfirmationFixIndexDialog from "./components/OrderConfirmationFixIndexDialog.vue"
import ApproveDialog from "./components/ApproveDialog.vue"

export default {
	filters: {
		dateFormatter(date) {
			if (date) {
				return moment(date).format("YYYY/MM/DD")
			}
		},
		datetimeFormatter(date) {
			if (date) {
				return moment(date).format("YYYY/MM/DD HH:mm")
			}
		},
		sourceOfBaseMaterialFormatter(item) {
			switch (item) {
				case "free":
					return "無償支給"
					break
				case "own":
					return "KG手配"
					break
			}
		},
		arrangementAvailabilityFormatter(item) {
			switch (item) {
				case true:
					return "可"
					break
				case false:
					return "否"
					break
			}
		},
		sourceOfTransportFormatter(item) {
			switch (item) {
				case "own":
					return "KG手配"
					break
				case "accepting":
					return "引取(工場渡し)"
					break
				case "direct":
					return "直送"
					break
			}
		},
		booleanFormatter(item) {
			switch (item) {
				case true:
					return "有"
					break
				case false:
					return "無"
					break
			}
		},
		approvalFormatter(item) {
			switch (item) {
				case "yet":
					return "未承認"
					break
				case "approved":
					return "承認済み"
					break
				case "reject":
					return "非承認"
					break
			}
		},
	},
	components: {
		CommonFlame,
		FunctionTitle,
		OrderConfirmationFixIndexDialog,
		ApproveDialog,
	},
	data() {
		return {
			mainTitle: "受注内容確認書",
			pageTitle: "受注内容確認書詳細",
			order_confirmation: {
				approval_status: null,
				matter: {
					customer_company: {
						name: "",
					},
					plant_customer_company: {
						name: "",
					},
				},
				order_confirmation_fixes: [],
				created_user: {
					full_name: null,
				},
				approved_users: []
			},
			id: this.$route.params["id"],
			matter_id: this.$route.params["matter_id"],
			authorized: false,
			fixDialog: false,
			approveDialog: false,
			is_approved: false,
			index: null,
		}
	},
	mounted() {
		this.fetchOrderConfirmation()
		if (this.$route.query.open) {
			this.fixDialog = true
		}
	},
	methods: {
		approve() {
			const headers = authenticate.setHeader()
			axios
				.post(`/erp/v1/order_confirmations/${this.id}/approvals`, {}, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "承認しました。",
					})
					this.is_approved = true
					this.approveDialog = false
					this.order_confirmation.approval_status = res.data.order_confirmation.approval_status
					this.order_confirmation.approved_users = res.data.order_confirmation.approved_users
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		reject(reason) {
			this.approveDialog = false

			const headers = authenticate.setHeader()
			axios
				.delete(`/erp/v1/order_confirmations/${this.id}/approvals`, {
					params: { reason: reason },
					headers,
				})
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "alert",
						text: "承認を却下しました。",
					})
					this.approveDialog = false
					this.order_confirmation.approval_status = res.data.order_confirmation.approval_status
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		fetchOrderConfirmation() {
			const headers = authenticate.setHeader()

			axios
				.get(`/erp/v1/order_confirmations/${this.id}`, {
					params: { matter_id: this.matter_id },
					headers,
				})
				.then((res) => {
					this.order_confirmation = res.data.order_confirmation
					this.authorized = res.data.authorized
					this.is_approved = res.data.is_approved
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		redirectToEditPage() {
			this.$router.push({
				name: "order_confirmation_edit",
				params: { matter_id: this.matter_id, id: this.id },
			})
		},
		openFixDialog() {
			this.fixDialog = true
		},
		openApprovalDialog() {
			this.approveDialog = true
		},
	},
}
</script>

<style lang="scss" scoped>
.product-info {
 .border{
  border-bottom: 1px solid #f5f5f5;
	padding-top: 8px;
	width: 90%;
  }
  &:last-child{
		.border{
			border-bottom: none;
		}
  }
}
.warning-text-color {
	color: black !important;
}
.success-text-color {
	color: #4caf4f !important;
}
.link {
	text-decoration: underline;
}
.text-body-2--new-line {
	white-space: pre-wrap;
}
</style>
